import * as React from 'react';

import styles from './styles.module.scss';

interface OwnProps {
	groupName: string;
	isSelected: boolean;
	onClick: (group: string) => void;
}

type Props = OwnProps;

const GroupEntry: React.FC<Props> = (props: Props) => {
	const { groupName, isSelected, onClick } = props;

	const handleClick = React.useCallback(() => {
		onClick(groupName);
	}, [groupName, onClick]);

	const resolvedClassName = React.useMemo(() => `${styles.GroupEntry} ${isSelected ? styles.isSelected : ''}`, [isSelected]);

	return (
		<div className={resolvedClassName} onClick={handleClick}>
			<div className={styles.name}>{groupName}</div>
			<span className={`${styles.caret} icon-right`} />
		</div>
	);
};

export default React.memo(GroupEntry);
